import { render, staticRenderFns } from "./morningDetails.vue?vue&type=template&id=0fa707aa&scoped=true&"
import script from "./morningDetails.vue?vue&type=script&lang=js&"
export * from "./morningDetails.vue?vue&type=script&lang=js&"
import style0 from "./morningDetails.vue?vue&type=style&index=0&style=true&lang=scss&"
import style1 from "./morningDetails.vue?vue&type=style&index=1&id=0fa707aa&style=true&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa707aa",
  null
  
)

component.options.__file = "morningDetails.vue"
export default component.exports